var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('image-entity-background');
import { breakpoints, theme } from '@shapeable/theme';
import { trimEnd } from 'lodash';
import { applyAspectRatio } from '../elements/responsive-container';
import { ImageEntityInfoTooltip } from './image-entity-info-tooltip';
export var ImageEntityBackgroundDefaultProps = {
  bodyStyle: {},
  style: {},
  showInfo: false
}; // -------- Styles -------->

var topBG = function topBG(value) {
  if (value) {
    return trimEnd(value, ',') + ", ";
  }

  return '';
};

var IMAGE = function IMAGE(key, topKey) {
  return function (props) {
    return props.entity && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-image: ", " url(", ");\n"], ["\n  background-image: ", " url(", ");\n"])), topBG(props[topKey]), props.entity[key] && props.entity[key].url || props.entity.image && props.entity.image.url);
  };
};

var IMAGES = function IMAGES(key, topKey) {
  return function (props) {
    return !!(props.items || []).length && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-image:  ", " ", ";\n"], ["\n  background-image:  ", " ", ";\n"])), topBG(props[topKey]), (props.items || []).map(function (entity) {
      return "url(" + (entity[key] && entity[key].url || entity.image && entity.image.url) + ")";
    }).join(","));
  };
};

var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    box-sizing: border-box;\n\n    ", "\n\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    position: relative;\n    display: flex;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    box-sizing: border-box;\n\n    ", "\n\n    ", ";\n    ", ";\n    ", ";\n  "])), function (_a) {
    var aspectRatio = _a.aspectRatio;
    return aspectRatio && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      position: relative;\n      overflow: hidden;\n    "], ["\n      position: relative;\n      overflow: hidden;\n    "])));
  }, applyAspectRatio('base'), IMAGE('portraitImage', 'baseTopImageStyles'), IMAGES('portraitImage', 'baseTopImageStyles')),
  landscape: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('landscape'), IMAGE('landscapeImage', 'landscapeTopImageStyles'), IMAGES('landscapeImage', 'landscapeTopImageStyles')),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('tablet'), IMAGE('tabletImage', 'tabletTopImageStyles'), IMAGES('tabletImage', 'tabletTopImageStyles')),
  desktop: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('desktop'), IMAGE('image', 'desktopTopImageStyles'), IMAGES('image', 'desktopTopImageStyles')),
  desktopLarge: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n    ", ";\n  "])), applyAspectRatio('large'), IMAGE('largeImage', 'desktopLargeTopImageStyles'), IMAGES('largeImage', 'desktopLargeTopImageStyles'))
});
var BodyStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-self: stretch;\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    box-sizing: border-box;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-self: stretch;\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), function (_a) {
    var padding = _a.padding;
    return padding && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), padding);
  }, function (_a) {
    var unitPadding = _a.unitPadding;
    return unitPadding && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme.UNIT(unitPadding));
  }, function (_a) {
    var overlayColor = _a.overlayColor;
    return overlayColor && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), overlayColor);
  })
});
var InfoTooltipStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    position: absolute;\n    left: ", ";\n    bottom: ", ";\n    z-index: 200;\n  "], ["\n    position: absolute;\n    left: ", ";\n    bottom: ", ";\n    z-index: 200;\n  "])), theme.UNIT(4), theme.UNIT(4)),
  tablet: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    left: ", ";\n    bottom: ", ";\n  "], ["\n    left: ", ";\n    bottom: ", ";\n  "])), theme.UNIT(7), theme.UNIT(7)),
  desktop: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    left: ", ";\n    bottom: ", ";\n  "], ["\n    left: ", ";\n    bottom: ", ";\n  "])), theme.UNIT(8), theme.UNIT(8))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  InfoTooltip: styled(ImageEntityInfoTooltip).attrs(cls.attr('info-tooltip'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), InfoTooltipStyles)
};
export var ImageEntityBackground = function ImageEntityBackground(props) {
  var className = props.className,
      aspectRatio = props.aspectRatio,
      entity = props.entity,
      items = props.items,
      _a = props.infoTooltipProps,
      infoTooltipProps = _a === void 0 ? {} : _a,
      showInfo = props.showInfo,
      children = props.children,
      onClick = props.onClick,
      unitPadding = props.unitPadding,
      bodyStyle = props.bodyStyle,
      style = props.style,
      padding = props.padding,
      overlayColor = props.overlayColor;
  var containerProps = {
    entity: entity,
    items: items
  };
  var baseTopImageStyles = props.baseTopImageStyles,
      landscapeTopImageStyles = props.landscapeTopImageStyles,
      tabletTopImageStyles = props.tabletTopImageStyles,
      desktopTopImageStyles = props.desktopTopImageStyles,
      desktopLargeTopImageStyles = props.desktopLargeTopImageStyles;
  var topProps = {
    baseTopImageStyles: baseTopImageStyles,
    landscapeTopImageStyles: landscapeTopImageStyles,
    tabletTopImageStyles: tabletTopImageStyles,
    desktopTopImageStyles: desktopTopImageStyles,
    desktopLargeTopImageStyles: desktopLargeTopImageStyles
  };
  return React.createElement(My.Container, __assign({}, containerProps, topProps, {
    onClick: onClick,
    style: style,
    aspectRatio: aspectRatio,
    className: cls.name(className)
  }), showInfo && React.createElement(My.InfoTooltip, __assign({
    entity: entity
  }, infoTooltipProps)), React.createElement(My.Body, {
    style: bodyStyle,
    unitPadding: unitPadding,
    padding: padding,
    overlayColor: overlayColor
  }, children));
};
ImageEntityBackground.defaultProps = ImageEntityBackgroundDefaultProps;
ImageEntityBackground.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;